import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { skuit } from 'src/services/skuit'
import useProfileContext from 'src/context/ProfileContext'

export const UnmaskPage = () => {
  const profileContext = useProfileContext()
  const history = useHistory()

  useEffect(() => {
    skuit.auth.unMask()
    profileContext.unsetProfile()
    history.push('/')
  }, [history, profileContext])
  return <></>
}
